import {
  QueryClient,
  useQueryClient,
  UseQueryOptions,
} from "@tanstack/react-query";
import { useCallback } from "react";

export const queryOptionsSingleShot = {
  retry: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
  gcTime: Infinity,
} satisfies Partial<UseQueryOptions>;

export const invalidateQueryKeys = (
  queryClient: QueryClient,
  ...queryKeys: (readonly [string, ...unknown[]])[]
) =>
  Promise.allSettled(
    queryKeys.map((queryKey) =>
      queryClient.invalidateQueries({
        queryKey,
      }),
    ),
  );

export const useInvalidateQueryKeys = () => {
  const queryClient = useQueryClient();
  const invalidateQuery = useCallback(
    async (...queryKeys: (readonly [string, ...unknown[]])[]) =>
      Promise.allSettled(
        queryKeys.map((queryKey) =>
          queryClient.invalidateQueries({
            queryKey,
          }),
        ),
      ),
    [queryClient],
  );
  return invalidateQuery;
};
